import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=7a92c1e7&scoped=true&"
import script from "./Ads.vue?vue&type=script&lang=js&"
export * from "./Ads.vue?vue&type=script&lang=js&"
import style0 from "./Ads.vue?vue&type=style&index=0&id=7a92c1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a92c1e7",
  null
  
)

export default component.exports